import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "sidebar-logo-container"
};
var _hoisted_2 = ["src"];
import setting from '@/settings.js';
import logoPng from '@/assets/images/logo.png';
import { ref, toRefs } from 'vue';

import { watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var prop = __props;
    var _toRefs = toRefs(prop),
      collapse = _toRefs.collapse;
    var title = ref(setting.title);
    var logo = logoPng;
    var isCollapse = ref(false);
    watch(collapse, function () {
      if (!collapse.value) {
        setTimeout(function () {
          isCollapse.value = collapse.value;
        }, 200);
      } else {
        isCollapse.value = collapse.value;
      }
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'collapse': _unref(collapse)
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
        key: "collapse",
        class: "sidebar-logo-link",
        to: "/"
      }, {
        default: _withCtx(function () {
          return [_unref(logo) ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(logo),
            class: "sidebar-logo"
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", {
            class: "sidebar-title"
          }, _toDisplayString(title.value), 513), [[_vShow, !isCollapse.value]])];
        }),
        _: 1
      })])], 2);
    };
  }
});